import React, {useEffect, useState} from 'react';
import './App.css';
import {ConfigProvider} from 'antd';
import locale from 'antd/lib/locale/ko_KR';
import {BrowserRouter} from 'react-router-dom';
import Container from '@layout/Container';
import {produce} from 'immer';
import Header from '@layout/Header';
import Footer from '@layout/Footer';
import '@scss/Common.scss';
import Login from '@page/Login';
import {useRecoilState} from 'recoil';
import {sessionInfoAtom} from '@atom/sessionInfoAtom';
import {getUserLoginInfo} from '@api/CommonApi';
import {HttpStatusCode} from 'axios';
import ChangePasswordPopup from '@page/ChangePasswordPopup';
import {User} from '@interface/master/UserManagementIF';

function App() {
    const [sessionInfo, setSessionInfo] = useRecoilState(sessionInfoAtom);
    const [showErrorPage, setShowErrorPage] = useState(false);
    const [isLogin, setIsLogin] = useState<boolean|undefined>(undefined);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [passwdSetUser,setPasswdSetUser] = useState<User>();


const getLoginUserInfo = async() => {
        getUserLoginInfo().then((res)=> {
             if(res != null) {
                if(res.code === HttpStatusCode.Ok && res.item) {
                    if(!res.item.passwdSetFlag) {
                        setPasswdSetUser(res.item);
                        return;
                    }

                    setIsLogin(true);
                    if( sessionInfo.userId !== res.item.userId)
                        setSessionInfo({userId:res.item.userId
                                    , userName:res.item.userName
                                    , admFlag:res.item.admFlag});
                }
                else {
                    setIsLogin(false);
                }
            }
        });

    };

    useEffect(() => {
        getLoginUserInfo().then();
    }, []);

    useEffect(() => {
        if(passwdSetUser) setIsOpen(true);
    }, [passwdSetUser]);
    return (
          <ConfigProvider locale={locale} >
              {isLogin?
                  <BrowserRouter>
                      {showErrorPage || <Header />}
                      {isLogin && <Container onChange={(flag:boolean)=> setShowErrorPage(produce(showErrorPage, ()=> flag))} />}
                      {showErrorPage || <Footer />}
                  </BrowserRouter>
                  :isLogin===false?
                      <Login /> : <></>
              }

              {passwdSetUser&&
            <ChangePasswordPopup
                userInfo={passwdSetUser}
                open={isOpen}
                title={'비밀번호 변경'}
                maskClosable={false}
                style={{minWidth: '400px'}}
                onOk={()=>{setIsOpen(false);location.href = location.pathname;}}
                onCancel={()=>setIsOpen(false)}
            />
            }
          </ConfigProvider>
    );
}

export default App;
